import { render, staticRenderFns } from "./ns-sticky-nav.vue?vue&type=template&id=5b1772a4&scoped=true&"
import script from "./ns-sticky-nav.vue?vue&type=script&lang=js&"
export * from "./ns-sticky-nav.vue?vue&type=script&lang=js&"
import style0 from "./ns-sticky-nav.vue?vue&type=style&index=0&id=5b1772a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1772a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1772a4')) {
      api.createRecord('5b1772a4', component.options)
    } else {
      api.reload('5b1772a4', component.options)
    }
    module.hot.accept("./ns-sticky-nav.vue?vue&type=template&id=5b1772a4&scoped=true&", function () {
      api.rerender('5b1772a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/ns-app-elements/src/ns-sticky-nav/ns-sticky-nav.vue"
export default component.exports